import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function SindhIncarceration() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Stories of Incarceration</h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="text-p-orange">Sleeping, Waking, Living</p>
          <p>
            Malik believes violence was directed at him due to him being Mohajir
            and his political affiliation, and that he was deliberately
            transferred to Khairpur for additional punishment. Here his own
            sense of ethnic superiority comes out against a sense of injustice
            he felt within a Sindhi milieu. His experience can be understood
            within the geography of incarceration where prisoner relocation is
            part of the system of punishment.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/MALIK.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">Conditions in Captivity</p>
          <p>
            Sharjeel observed similarities and differences across various jails
            and between his treatment and those of other prisoners who came from
            more vulnerable socioeconomic backgrounds. His experience shows how
            an economy of extortion and punitive violence along segregated
            spatial lines are the legend to an urban and provincial map of
            securitisation in Sindh.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/SHARJEEL.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SindhIncarceration;
